import type { CdnPath, CdnPathPart } from "./cdnPath";

export function buildCdnPath(pathParts: readonly CdnPathPart[]): CdnPath {
  const path = pathParts
    .map((part) => String(part).replace(/^\/+|\/+$/gu, ""))
    .filter(Boolean)
    .map(encodeURIComponent)
    .join("/");
  return `/cdn/${path}` as CdnPath;
}
